import { useEffect, useState } from 'react';
import { changeUserPassword } from '../../sp-firebase/userFB';
import { ComponentProps } from './LoginPage';
import React from 'react';
import { useUser } from '../../hooks/useUser';
import { CloseButton } from '../UI-Elements/Buttons/CloseButton';

const ChangePassword: React.FC<ComponentProps> = ({ setActiveComponent }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [isPasswordRequired, setIsPasswordRequired] = useState(false);

  const [isConfirmPasswordRequired, setIsConfirmPasswordRequired] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [registrationToken, setRegistrationToken] = useState('');

  const { data: user } = useUser();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setRegistrationToken(urlParams.get('token') as string);
    // Now you can use the registrationToken for registration logic
    // For example, make an API request to complete registration
  }, []);

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    setIsPasswordRequired(e.target.value !== '');
    // Reset the error message when the password changes
    setError('');
  };

  const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmPassword(e.target.value);
    setIsConfirmPasswordRequired(e.target.value !== '');
    // Reset the error message when the confirm password changes
    setError('');
  };

  const handleCreatePassword = async () => {
    if (verifyPassword()) {
      try {
        await changeUserPassword(oldPassword, password);

        setChangedSuccess(true);
      } catch (error: any | Error) {
        setError(
          'Failed to change password. ' + (error?.message?.includes('invalid-credential') ? 'wrong password.' : error),
        );
      }
    }
  };

  const validatePasswordConfirmation = () => {
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return false;
    }
    return true;
  };

  const verifyPassword = () => {
    if (!oldPassword) {
      setError('Old password is required');
      return false;
    }
    if (!validatePasswordConfirmation()) {
      return false;
    }
    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
    const isValidPassword = passwordPattern.test(password);

    if (!isValidPassword) {
      setError('Password must have at least 6 characters and include letters, capital letters, and numbers.');
    }
    return isValidPassword;
  };
  const [changedSuccess, setChangedSuccess] = React.useState(false);

  return (
    <div className="max-w-[500px] h-full p-5 bg-white rounded align-items-center">
      {changedSuccess ? (
        <div className="flex flex-col gap-2 p-2 text-center">
          <p className="text-xl text-green-600">Password changed successfully!</p>
          <div className="flex justify-center mt-4">
            <button
              type="button"
              onClick={() => setActiveComponent('Close')}
              className="bg-purple border rounded text-white text-sm ms-4 h-[4vh] w-[9vw]"
            >
              OK
            </button>
          </div>
        </div>
      ) : (
        <form>
          <div className="flex justify-between mb-4">
            <p className="text-xl text-red">Change password</p>
            <CloseButton onClick={() => setActiveComponent('Close')} />
          </div>
          <div className="py-4">
            <p>Hi, {user?.name || ''} </p>
            <p>
              change password for email: <span className="text-blue-600">{user?.email || ''} </span>
            </p>
          </div>

          <div className="mb-3">
            <label className="text-xs">
              Old Password <span className="text-red text-base ps-1">*</span>
            </label>

            <input
              className="text-sm border-1 mt-1 p-2 opacity-40 h-[2.75vh] w-[15vw] rounded"
              type="password"
              placeholder="Enter old password"
              value={oldPassword}
              onChange={({ target }) => setOldPassword(target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="text-xs">
              Password {!isPasswordRequired && <span className="text-red text-base ps-1">*</span>}{' '}
            </label>

            <input
              className="text-sm border-1 mt-1 p-2 opacity-40 h-[2.75vh] w-[15vw] rounded"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={handlePasswordChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="text-xs">
              Confirm password {!isConfirmPasswordRequired && <span className="text-red text-base ps-1">*</span>}
            </label>
            <input
              className="text-sm border-1 mt-1 p-2 opacity-40 h-[2.75vh] w-[15vw] rounded"
              type="password"
              placeholder="Enter password"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              onKeyUp={validatePasswordConfirmation}
              required
            />
          </div>
          {error && <div className="text-red">{error}</div>}

          <button
            type="button"
            className="bg-gray-700 opacity-50 border rounded text-white text-sm h-[4vh] w-[6vw]"
            onClick={() => {
              setActiveComponent('Login');
            }}
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleCreatePassword}
            className="bg-purple border rounded text-white text-sm ms-4 h-[4vh] w-[9vw]"
          >
            Create password
          </button>
        </form>
      )}
    </div>
  );
};

export default ChangePassword;
